import Button from "components/buttons/Button"
import useTranslations from "hooks/useTranslations"
import cc from "classcat"

type RequestButtonProps = {
  bgStyle?:
    | "primary"
    | "light"
    | "dark"
    | "blue"
    | "yellow"
    | "cadetblue"
    | "black"
    | "green"
  left?: boolean
}

const RequestButton = ({ bgStyle = "primary", left }: RequestButtonProps) => {
  const { hrHeroButton1, appointmentLink } = useTranslations()
  return (
    <div className={cc(["max-w-xs", left ? "" : "mx-auto"])}>
      <Button
        bgStyle={bgStyle}
        label={hrHeroButton1}
        link={appointmentLink}
        outbound
      />
    </div>
  )
}

export default RequestButton
